import { Component, OnInit } from '@angular/core';
import { NavParams } from '@ionic/angular';

@Component({
  selector: 'app-replace-media-popover',
  templateUrl: './replace-media-popover.component.html',
  styleUrls: ['./replace-media-popover.component.scss'],
})
export class ReplaceMediaPopoverComponent implements OnInit {

  public option: string = "";

  constructor(
    public navParams: NavParams,
  ) { 
    this.option = this.navParams.get('option');
  }

  ngOnInit() {}

}
